export default __webpack_public_path__ + "static/media/self-info-bg.12470ee4.png";